/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-13 09:39:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-06 17:34:05
 */

// 邮件模板
import http from "../httpConfig";

const table = "mrbase_sys_mail_template";

// 获取模板列表
export const getemailtemplatelist = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/mailtemplate/list-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取模板详情
export const getdetailemailtemplate = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/mailtemplate/find-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 邮件模板新增
export const addemailtemplate = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/mailtemplate/add-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 邮件模板修改
export const updateemailtemplate = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/mailtemplate/update-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 邮件模板删除
export const deleteemailtemplate = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/mailtemplate/delete-template/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 邮件系统变量
export const templatesysList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/mail/getMailTemplateSysParam/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
